import gsap from "gsap";

const AnimatedBorder = (element) => {
  const borderTop = element.querySelector(".animatedBorder__line--top");
  const borderBottom = element.querySelector(".animatedBorder__line--bottom");
  const borderLeft = element.querySelector(".animatedBorder__line--left");
  const borderRight = element.querySelector(".animatedBorder__line--right");

  const delay = parseInt(element.getAttribute("data-delay"), 10) || 0;

  const animate = () => {
    const durations = [0.35, 0.75];
    const delayInSeconds = delay / 1000;

    gsap.to(borderLeft, { scaleY: 1, duration: durations[0], ease: "power2.in", delay: delayInSeconds });
    gsap.to(borderRight, { scaleY: 1, duration: durations[0], ease: "power2.in", delay: delayInSeconds });
    
    gsap.to(borderTop, { scaleX: 1, duration: durations[1], ease: "power4.out", delay: durations[0] + delayInSeconds });
    gsap.to(borderBottom, { scaleX: 1, duration: durations[1], ease: "power4.out", delay: durations[0] + delayInSeconds });
  };

  const main = () => {
    animate();
  }

  main();
};

export default AnimatedBorder;
